module.exports = __webpack_public_path__ + "HelveticaOblique.c4782ea36efc77efd0aa.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaOblique.svg
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaOblique.svg
// module chunks = styles